import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵdefineComponent, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, Component, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, ɵɵelementContainerStart, ɵɵnamespaceSVG, ɵɵelement, ɵɵelementContainerEnd, ɵɵnextContext, ɵɵadvance, ɵɵtextInterpolate, ɵɵgetCurrentView, ɵɵtemplate, ɵɵlistener, ɵɵrestoreView, ɵɵproperty, ɵɵpureFunction1, ɵɵtextInterpolate1, EventEmitter, ɵɵprojectionDef, ɵɵprojection, ɵɵreference, Input, Output, ɵɵdirectiveInject, ElementRef, HostListener, ɵɵattribute, ɵɵviewQuery, ɵɵqueryRefresh, ɵɵloadQuery, ɵɵProvidersFeature, ɵɵNgOnChangesFeature, ɵɵpipe, ɵɵpipeBind1, ChangeDetectionStrategy, ViewChild, ɵɵinject, ComponentFactoryResolver, ViewContainerRef, ɵɵdefineDirective, Directive, ɵɵInheritDefinitionFeature, ɵɵgetInheritedFactory, Renderer2, ɵɵstaticViewQuery } from '@angular/core';
import { RouterLinkWithHref, RouterModule } from '@angular/router';
import { NgIf, NgClass, CommonModule, NgForOf, NgStyle, AsyncPipe } from '@angular/common';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { fromEvent, BehaviorSubject, timer } from 'rxjs';
import { takeWhile, withLatestFrom, tap, debounceTime, distinctUntilChanged, map, startWith, take } from 'rxjs/operators';
import { ComponentStore } from '@ngrx/component-store';

class ElementsLibService {
    constructor() { }
}
ElementsLibService.ɵfac = function ElementsLibService_Factory(t) { return new (t || ElementsLibService)(); };
ElementsLibService.ɵprov = ɵɵdefineInjectable({ token: ElementsLibService, factory: ElementsLibService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ElementsLibService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ElementsLibComponent {
    constructor() { }
    ngOnInit() {
    }
}
ElementsLibComponent.ɵfac = function ElementsLibComponent_Factory(t) { return new (t || ElementsLibComponent)(); };
ElementsLibComponent.ɵcmp = ɵɵdefineComponent({ type: ElementsLibComponent, selectors: [["lib-elements-lib"]], decls: 2, vars: 0, template: function ElementsLibComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, " elements-lib works! ");
        ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ElementsLibComponent, [{
        type: Component,
        args: [{
                selector: 'lib-elements-lib',
                template: `
    <p>
      elements-lib works!
    </p>
  `,
                styles: []
            }]
    }], function () { return []; }, null); })();

class ElementsLibModule {
}
ElementsLibModule.ɵmod = ɵɵdefineNgModule({ type: ElementsLibModule });
ElementsLibModule.ɵinj = ɵɵdefineInjector({ factory: function ElementsLibModule_Factory(t) { return new (t || ElementsLibModule)(); }, imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ElementsLibModule, { declarations: [ElementsLibComponent], exports: [ElementsLibComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ElementsLibModule, [{
        type: NgModule,
        args: [{
                declarations: [ElementsLibComponent],
                imports: [],
                exports: [ElementsLibComponent]
            }]
    }], null, null); })();

function HeaderComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵnamespaceSVG();
    ɵɵelementStart(1, "svg", 5);
    ɵɵelementStart(2, "defs");
    ɵɵelementStart(3, "style");
    ɵɵtext(4, " .a { fill: #fff; } .b { fill: #20a9e3; } ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(5, "g", 6);
    ɵɵelementStart(6, "g", 7);
    ɵɵelement(7, "path", 8);
    ɵɵelement(8, "path", 9);
    ɵɵelement(9, "path", 10);
    ɵɵelement(10, "path", 11);
    ɵɵelement(11, "path", 12);
    ɵɵelement(12, "path", 13);
    ɵɵelement(13, "path", 14);
    ɵɵelement(14, "path", 15);
    ɵɵelement(15, "path", 16);
    ɵɵelement(16, "path", 17);
    ɵɵelement(17, "path", 18);
    ɵɵelementStart(18, "g", 19);
    ɵɵelement(19, "path", 20);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
function HeaderComponent_div_7_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 25);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r3.userToolTip);
} }
const _c0 = function (a0) { return { "tooltip": a0 }; };
function HeaderComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 21);
    ɵɵelementStart(1, "span", 22);
    ɵɵtext(2);
    ɵɵtemplate(3, HeaderComponent_div_7_span_3_Template, 2, 1, "span", 23);
    ɵɵelementEnd();
    ɵɵelementStart(4, "span", 24);
    ɵɵlistener("click", function HeaderComponent_div_7_Template_span_click_4_listener() { ɵɵrestoreView(_r5); const ctx_r4 = ɵɵnextContext(); return ctx_r4.logout(); });
    ɵɵtext(5, "Logout");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction1(3, _c0, !!ctx_r2.userToolTip));
    ɵɵadvance(1);
    ɵɵtextInterpolate1("Welcome ", ctx_r2.username, " ");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2.userToolTip);
} }
const _c1 = [[["", "logo", ""]], "*"];
const _c2 = function (a0) { return [a0]; };
const _c3 = ["[logo]", "*"];
class HeaderComponent {
    constructor() {
        this.onLogout = new EventEmitter();
    }
    ngOnInit() {
    }
    logout() {
        this.onLogout.emit();
    }
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(); };
HeaderComponent.ɵcmp = ɵɵdefineComponent({ type: HeaderComponent, selectors: [["lib-header"]], inputs: { username: "username", loggedIn: "loggedIn", userToolTip: "userToolTip", homepage: "homepage" }, outputs: { onLogout: "onLogout" }, ngContentSelectors: _c3, decls: 8, vars: 5, consts: [[1, "header"], [3, "routerLink"], ["logo", ""], [4, "ngIf"], ["class", "user", 4, "ngIf"], ["xmlns", "http://www.w3.org/2000/svg", "width", "110", "height", "21.27", "viewBox", "0 0 110 21.27", 1, "logo"], ["transform", "translate(51 -73)"], ["transform", "translate(-51 73)"], ["d", "M243.9,405.815v-2.2h2.137v-3h2.591v3h2.849v2.2H248.63v6.334c0,1.037.3,1.684,1.446,1.684a2.7,2.7,0,0,0,1.4-.323v2.182a5.479,5.479,0,0,1-2.05.344c-2.742,0-3.39-1.231-3.39-3.67v-6.55Z", "transform", "translate(-216.979 -399.715)", 1, "a"], ["d", "M295.215,434.212A2.685,2.685,0,0,0,298,436.672a3.4,3.4,0,0,0,2.784-1.4l1.858,1.4a5.542,5.542,0,1,1-4.383-8.808c2.892,0,4.858,2.029,4.858,5.636v.712Zm5.311-1.943a2.384,2.384,0,0,0-2.634-2.461,2.576,2.576,0,0,0-2.677,2.461Z", "transform", "translate(-257.631 -422.482)", 1, "a"], ["d", "M364.539,395.233h2.591v16.32h-2.591Z", "transform", "translate(-317.607 -395.233)", 1, "a"], ["d", "M392.4,395.233h2.591v16.32H392.4Z", "transform", "translate(-340.849 -395.233)", 1, "a"], ["d", "M420.264,430.985h2.591v10.361h-2.591Z", "transform", "translate(-364.093 -425.086)", 1, "a"], ["d", "M455.944,428.957v9.432c0,3.736-1.812,6.111-5.85,6.111a7.379,7.379,0,0,1-5.136-1.705l1.554-2.116a5,5,0,0,0,3.561,1.491c2.5,0,3.282-1.426,3.282-3.477v-.756h-.044a4.215,4.215,0,0,1-3.389,1.511,5.076,5.076,0,0,1-5.159-5.31c0-3.066,1.921-5.441,5.117-5.441a4,4,0,0,1,3.561,1.814h.042v-1.554Zm-8.592,5.157a2.993,2.993,0,0,0,3.045,3,3.045,3.045,0,1,0-3.045-3Z", "transform", "translate(-384.557 -423.23)", 1, "a"], ["d", "M523.157,434.212a2.686,2.686,0,0,0,2.786,2.461,3.4,3.4,0,0,0,2.784-1.4l1.858,1.4a5.542,5.542,0,1,1-4.384-8.808c2.893,0,4.859,2.029,4.859,5.636v.712Zm5.312-1.943a2.384,2.384,0,0,0-2.633-2.461,2.578,2.578,0,0,0-2.679,2.461Z", "transform", "translate(-447.797 -422.482)", 1, "a"], ["d", "M592.228,429.685h2.461v1.661h.044a3.249,3.249,0,0,1,3.173-1.921c2.784,0,3.779,1.965,3.779,4.081v6.539h-2.591V434.8c0-1.145-.088-3.045-1.9-3.045-1.707,0-2.375,1.253-2.375,2.635v5.655h-2.591Z", "transform", "translate(-507.667 -423.784)", 1, "a"], ["d", "M653.522,405.815v-2.2h2.138v-3h2.591v3H661.1v2.2h-2.849v6.334c0,1.037.3,1.684,1.447,1.684a2.7,2.7,0,0,0,1.4-.323v2.182a5.484,5.484,0,0,1-2.051.344c-2.742,0-3.389-1.231-3.389-3.67v-6.55Z", "transform", "translate(-558.744 -399.715)", 1, "a"], ["d", "M104.759,427.7a3.606,3.606,0,0,0-3.411,1.921,3.162,3.162,0,0,0-3.239-1.921,3.294,3.294,0,0,0-3.173,1.877h-.043v-1.617H92.431v5.813l-2.156-.384a3.4,3.4,0,0,1-1.847,2.516,2.687,2.687,0,0,1-3.6-.928l7.046-3.59-.324-.636c-1.637-3.215-4.311-4.131-6.891-2.82a5.446,5.446,0,1,0,7.772,6.279v4.11h2.591v-5.655c0-1.381.669-2.635,2.375-2.635,1.251,0,1.77.843,1.77,2.116v6.174h2.59v-5.611c0-1.339.6-2.679,2.224-2.679,1.533,0,1.921,1.123,1.921,2.419v5.871h2.591v-6.174C108.493,429.661,107.522,427.7,104.759,427.7ZM85.214,429.83a2.385,2.385,0,0,1,3.467,1l-4.737,2.412A2.578,2.578,0,0,1,85.214,429.83Z", "transform", "translate(-81.475 -422.054)", 1, "b"], ["d", "M419.71,400.548a1.556,1.556,0,1,1-1.64,1.554A1.592,1.592,0,0,1,419.71,400.548Z", "transform", "translate(-362.265 -399.662)", 1, "b"], ["transform", "translate(103.713 1.121)"], ["d", "M707.957,402.572h-.834v-.615h2.365v.615h-.834v2.2h-.7Zm2.173-.615h.97l.67,1.832.67-1.832h.971v2.816h-.7v-1.831H712.7l-.69,1.831h-.478l-.69-1.831h-.014v1.831h-.7Z", "transform", "translate(-707.123 -401.957)", 1, "a"], [1, "user"], [1, "welcome", 3, "ngClass"], ["class", "tooltip-text", 4, "ngIf"], [1, "logout", 3, "click"], [1, "tooltip-text"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef(_c1);
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "a", 1);
        ɵɵelementStart(2, "div", null, 2);
        ɵɵprojection(4);
        ɵɵelementEnd();
        ɵɵtemplate(5, HeaderComponent_ng_container_5_Template, 20, 0, "ng-container", 3);
        ɵɵelementEnd();
        ɵɵprojection(6, 1);
        ɵɵtemplate(7, HeaderComponent_div_7_Template, 6, 5, "div", 4);
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵɵreference(3);
        ɵɵadvance(1);
        ɵɵproperty("routerLink", ɵɵpureFunction1(3, _c2, ctx.homepage));
        ɵɵadvance(4);
        ɵɵproperty("ngIf", !_r0.children.length);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.username && ctx.loggedIn);
    } }, directives: [RouterLinkWithHref, NgIf, NgClass], styles: ["[_nghost-%COMP%]{background-color:#000;display:block;width:100%}.header[_ngcontent-%COMP%]{box-sizing:border-box;display:flex;height:56px;justify-content:space-between;padding:19px 24px;width:100%}.user[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding-left:10px}.user[_ngcontent-%COMP%]   .login[_ngcontent-%COMP%], .user[_ngcontent-%COMP%]   .welcome[_ngcontent-%COMP%]{font-size:16px;font-weight:400}.user[_ngcontent-%COMP%]   .welcome[_ngcontent-%COMP%]{color:#fff}.user[_ngcontent-%COMP%]   .logout[_ngcontent-%COMP%]{color:#8f9fb3;cursor:pointer}.tooltip[_ngcontent-%COMP%]{cursor:help;display:inline-block;position:relative}.tooltip[_ngcontent-%COMP%]   .tooltip-text[_ngcontent-%COMP%]{background-color:#f7f7f7;border-radius:6px;box-shadow:1px 1px 5px rgba(68,57,76,.3607843137254902);color:#000;padding:5px;position:absolute;right:100%;text-align:center;top:-5px;visibility:hidden;z-index:1}.tooltip[_ngcontent-%COMP%]:hover   .tooltip-text[_ngcontent-%COMP%]{visibility:visible}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'lib-header',
                templateUrl: './header.component.html',
                styleUrls: ['./header.component.css']
            }]
    }], function () { return []; }, { username: [{
            type: Input
        }], loggedIn: [{
            type: Input
        }], userToolTip: [{
            type: Input
        }], homepage: [{
            type: Input
        }], onLogout: [{
            type: Output,
            args: ['onLogout']
        }] }); })();

class HeaderModule {
}
HeaderModule.ɵmod = ɵɵdefineNgModule({ type: HeaderModule });
HeaderModule.ɵinj = ɵɵdefineInjector({ factory: function HeaderModule_Factory(t) { return new (t || HeaderModule)(); }, imports: [[
            CommonModule,
            RouterModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(HeaderModule, { declarations: [HeaderComponent], imports: [CommonModule,
        RouterModule], exports: [HeaderComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(HeaderModule, [{
        type: NgModule,
        args: [{
                declarations: [HeaderComponent],
                imports: [
                    CommonModule,
                    RouterModule
                ],
                exports: [HeaderComponent]
            }]
    }], null, null); })();

class TopNavButtonComponent {
    constructor(hostElement) {
        this.hostElement = hostElement;
        this.clickEvent = new EventEmitter();
    }
    ngOnInit() {
    }
    onClick(event) {
        this.clickEvent.emit({
            id: this.navElement.id,
            element: this.hostElement
        });
    }
}
TopNavButtonComponent.ɵfac = function TopNavButtonComponent_Factory(t) { return new (t || TopNavButtonComponent)(ɵɵdirectiveInject(ElementRef)); };
TopNavButtonComponent.ɵcmp = ɵɵdefineComponent({ type: TopNavButtonComponent, selectors: [["lib-top-nav-button"]], hostBindings: function TopNavButtonComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("click", function TopNavButtonComponent_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } }, inputs: { navElement: "navElement" }, outputs: { clickEvent: "clickEvent" }, decls: 2, vars: 1, template: function TopNavButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "span");
        ɵɵtext(1);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵtextInterpolate(ctx.navElement.label);
    } }, styles: ["[_nghost-%COMP%]{color:grey;cursor:pointer;font-size:16px;padding:25px 0 21px;position:relative;transition:color .25s}[_nghost-%COMP%]:hover{color:#fec953}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TopNavButtonComponent, [{
        type: Component,
        args: [{
                selector: 'lib-top-nav-button',
                templateUrl: './top-nav-button.component.html',
                styleUrls: ['./top-nav-button.component.scss']
            }]
    }], function () { return [{ type: ElementRef }]; }, { navElement: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();

function TopNavBarComponent_lib_top_nav_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "lib-top-nav-button", 3);
    ɵɵlistener("clickEvent", function TopNavBarComponent_lib_top_nav_button_2_Template_lib_top_nav_button_clickEvent_0_listener($event) { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.onButtonClick($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const button_r1 = ctx.$implicit;
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("navElement", button_r1)("@activation", ctx_r0.active === button_r1.id ? "active" : "inactive");
} }
class TopNavBarComponent {
    constructor() {
        this.onChange = new EventEmitter();
    }
    set default(value) {
        if (value !== this._default) {
            this.setSelected();
            this._default = value;
        }
    }
    ngOnInit() {
        this.setSelected();
    }
    onButtonClick(event) {
        this.active = event.id;
        this.onChange.emit(event.id);
    }
    setSelected() {
        if (this.buttons.length > 0) {
            const defaultIndex = this.buttons.findIndex(b => b.id === this._default);
            const selected = this.buttons[defaultIndex !== -1 ? defaultIndex : 0].id;
            this.active = selected;
            this.onChange.emit(selected);
        }
    }
}
TopNavBarComponent.ɵfac = function TopNavBarComponent_Factory(t) { return new (t || TopNavBarComponent)(); };
TopNavBarComponent.ɵcmp = ɵɵdefineComponent({ type: TopNavBarComponent, selectors: [["lib-top-nav-bar"]], inputs: { buttons: "buttons", default: "default" }, outputs: { onChange: "onChange" }, decls: 3, vars: 1, consts: [[1, "nav-bar-wrapper"], [1, "nav-bar"], [3, "navElement", "clickEvent", 4, "ngFor", "ngForOf"], [3, "navElement", "clickEvent"]], template: function TopNavBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵtemplate(2, TopNavBarComponent_lib_top_nav_button_2_Template, 1, 2, "lib-top-nav-button", 2);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("ngForOf", ctx.buttons);
    } }, directives: [NgForOf, TopNavButtonComponent], styles: [".nav-bar-wrapper[_ngcontent-%COMP%]{background-color:#000;width:100%}.nav-bar[_ngcontent-%COMP%]{color:#fff;display:flex;flex-direction:row;justify-content:space-evenly;margin:auto;max-width:var(--page-max-width)}"], data: { animation: [
            trigger('activation', [
                state('active', style({
                    color: 'white',
                    borderBottom: '4px #fec953 solid'
                }))
            ])
        ] } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TopNavBarComponent, [{
        type: Component,
        args: [{
                selector: 'lib-top-nav-bar',
                templateUrl: './top-nav-bar.component.html',
                styleUrls: ['./top-nav-bar.component.scss'],
                animations: [
                    trigger('activation', [
                        state('active', style({
                            color: 'white',
                            borderBottom: '4px #fec953 solid'
                        }))
                    ])
                ]
            }]
    }], function () { return []; }, { buttons: [{
            type: Input
        }], default: [{
            type: Input
        }], onChange: [{
            type: Output
        }] }); })();

class TopNavModule {
}
TopNavModule.ɵmod = ɵɵdefineNgModule({ type: TopNavModule });
TopNavModule.ɵinj = ɵɵdefineInjector({ factory: function TopNavModule_Factory(t) { return new (t || TopNavModule)(); }, imports: [[
            CommonModule,
            BrowserModule,
            BrowserAnimationsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(TopNavModule, { declarations: [TopNavBarComponent,
        TopNavButtonComponent], imports: [CommonModule,
        BrowserModule,
        BrowserAnimationsModule], exports: [TopNavBarComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(TopNavModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TopNavBarComponent,
                    TopNavButtonComponent
                ],
                imports: [
                    CommonModule,
                    BrowserModule,
                    BrowserAnimationsModule
                ],
                exports: [
                    TopNavBarComponent,
                ]
            }]
    }], null, null); })();

const _c0$1 = ["*"];
var ChipStatus;
(function (ChipStatus) {
    ChipStatus["DISABLED"] = "disabled";
    ChipStatus["ENABLED"] = "enabled";
    ChipStatus["ACTIVE"] = "active";
})(ChipStatus || (ChipStatus = {}));
class ChipComponent {
    constructor() {
        this.clicked = new EventEmitter();
    }
    ngOnInit() {
    }
    onClick() {
        this.clicked.emit(this.chip);
    }
}
ChipComponent.ɵfac = function ChipComponent_Factory(t) { return new (t || ChipComponent)(); };
ChipComponent.ɵcmp = ɵɵdefineComponent({ type: ChipComponent, selectors: [["lib-chip"]], inputs: { chip: "chip" }, outputs: { clicked: "clicked" }, ngContentSelectors: _c0$1, decls: 3, vars: 3, consts: [[1, "chip", 3, "click"]], template: function ChipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "span", 0);
        ɵɵlistener("click", function ChipComponent_Template_span_click_0_listener() { return ctx.onClick(); });
        ɵɵprojection(1);
        ɵɵtext(2);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵattribute("data-count", ctx.chip.count)("data-status", ctx.chip.status);
        ɵɵadvance(2);
        ɵɵtextInterpolate1(" ", ctx.chip.label, "\n");
    } }, styles: [".chip[_ngcontent-%COMP%]{-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;border:1px solid var(--chip-active);border-radius:1em;color:var(--active);cursor:pointer;display:inline-block;font-size:16px;margin:4px;padding:4px 1em;text-transform:capitalize;user-select:none;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.chip[_ngcontent-%COMP%], .chip[_ngcontent-%COMP%]:before{transition-duration:.25s;transition-property:background-color,border-color,box-shadow,color}.chip[data-count][_ngcontent-%COMP%]:not([data-count=\"\"]){padding-left:4px}.chip[data-count][_ngcontent-%COMP%]:not([data-count=\"\"]):before{border:1px solid var(--chip-active);border-radius:1em;content:attr(data-count);font-size:14px;padding:0 4px}.chip[_ngcontent-%COMP%]:hover{background-color:var(--chip-hover);border-color:var(--chip-hover);box-shadow:0 2px 3px rgba(133,148,158,.5019607843137255);color:#fff}.chip[_ngcontent-%COMP%]:hover[data-count]:not([data-count=\"\"]):before{background-color:#fff;border-color:#fff;color:var(--chip-hover)}.chip[_ngcontent-%COMP%]:active, .chip[data-status=active][_ngcontent-%COMP%]{background-color:var(--chip-press);border-color:var(--chip-press);color:#fff}.chip[_ngcontent-%COMP%]:active[data-count]:not([data-count=\"\"]):before, .chip[data-status=active][data-count][_ngcontent-%COMP%]:not([data-count=\"\"]):before{background-color:var(--chip-press);border-color:#fff;color:#fff}.chip[data-status=disabled][_ngcontent-%COMP%]{background-color:var(--chip-disabled);border-color:var(--chip-disabled);color:#fff}.chip[data-status=disabled][data-count][_ngcontent-%COMP%]:not([data-count=\"\"]):before{background-color:inherit;border-color:#fff;color:inherit}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ChipComponent, [{
        type: Component,
        args: [{
                selector: 'lib-chip',
                templateUrl: './chip.component.html',
                styleUrls: ['./chip.component.scss']
            }]
    }], function () { return []; }, { chip: [{
            type: Input
        }], clicked: [{
            type: Output
        }] }); })();

class ChipModule {
}
ChipModule.ɵmod = ɵɵdefineNgModule({ type: ChipModule });
ChipModule.ɵinj = ɵɵdefineInjector({ factory: function ChipModule_Factory(t) { return new (t || ChipModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ChipModule, { declarations: [ChipComponent], imports: [CommonModule], exports: [ChipComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ChipModule, [{
        type: NgModule,
        args: [{
                declarations: [ChipComponent],
                imports: [
                    CommonModule
                ],
                exports: [
                    ChipComponent
                ]
            }]
    }], null, null); })();

const defaultState = {
    checked: false
};
class ToggleSwitchState extends ComponentStore {
    constructor() {
        super(defaultState);
        this.checked$ = this.select(state => state.checked);
        this.updateChecked = this.updater((state, checked) => {
            return Object.assign(Object.assign({}, state), { checked });
        });
    }
}
ToggleSwitchState.ɵfac = function ToggleSwitchState_Factory(t) { return new (t || ToggleSwitchState)(); };
ToggleSwitchState.ɵprov = ɵɵdefineInjectable({ token: ToggleSwitchState, factory: ToggleSwitchState.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ToggleSwitchState, [{
        type: Injectable
    }], function () { return []; }, null); })();

const _c0$2 = ["toggle"];
const _c1$1 = function (a0) { return { "checked": a0 }; };
const _c2$1 = function (a0) { return { "flex-direction": a0 }; };
const _c3$1 = ["*"];
class ToggleSwitchComponent {
    constructor(state) {
        this.state = state;
        this.isAlive = true;
        this.initialCheckedValue = defaultState.checked;
        this.onChange = new EventEmitter();
    }
    get checked$() {
        return this.state.checked$;
    }
    ngOnInit() {
        this.state.updateChecked(this.initialCheckedValue);
        this.checked$.pipe(takeWhile(() => this.isAlive)).subscribe(checked => {
            if (this.element) {
                this.element.nativeElement.checked = checked;
            }
            this.onChange.emit({
                value: checked,
                fromClick: false
            });
        });
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    ngAfterViewInit() {
        this.clicked$ = fromEvent(this.element.nativeElement, 'click');
        fromEvent(this.element.nativeElement, 'change').pipe(takeWhile(() => this.isAlive)).subscribe(event => {
            const checked = this.element.nativeElement.checked;
            this.state.updateChecked(checked);
        });
        this.clicked$.pipe(withLatestFrom(this.checked$), tap(([event, checked]) => {
            this.onChange.emit({
                value: !checked,
                fromClick: true
            });
        }), takeWhile(() => this.isAlive)).subscribe();
    }
    ngOnChanges(changes) {
        if (changes.value$ && changes.value$.firstChange) {
            changes.value$.currentValue
                .pipe(takeWhile(() => this.isAlive)).subscribe(inputValue => {
                this.initialCheckedValue = inputValue;
                this.state.updateChecked(inputValue);
            });
        }
    }
}
ToggleSwitchComponent.ɵfac = function ToggleSwitchComponent_Factory(t) { return new (t || ToggleSwitchComponent)(ɵɵdirectiveInject(ToggleSwitchState)); };
ToggleSwitchComponent.ɵcmp = ɵɵdefineComponent({ type: ToggleSwitchComponent, selectors: [["lib-toggle-switch"]], viewQuery: function ToggleSwitchComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$2, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.element = _t.first);
    } }, inputs: { direction: "direction", value$: ["value", "value$"] }, outputs: { onChange: "toggle" }, features: [ɵɵProvidersFeature([
            ToggleSwitchState
        ]), ɵɵNgOnChangesFeature], ngContentSelectors: _c3$1, decls: 7, vars: 9, consts: [[1, "toggle-switch", 3, "ngClass", "ngStyle"], [1, "label"], ["type", "checkbox"], ["toggle", ""], [1, "track"]], template: function ToggleSwitchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "label", 0);
        ɵɵpipe(1, "async");
        ɵɵelementStart(2, "span", 1);
        ɵɵprojection(3);
        ɵɵelementEnd();
        ɵɵelement(4, "input", 2, 3);
        ɵɵelement(6, "div", 4);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngClass", ɵɵpureFunction1(5, _c1$1, ɵɵpipeBind1(1, 3, ctx.checked$)))("ngStyle", ɵɵpureFunction1(7, _c2$1, ctx.direction === "left" ? "row" : "row-reverse"));
        ɵɵadvance(4);
        ɵɵattribute("checked", ctx.initialCheckedValue || null);
    } }, directives: [NgClass, NgStyle], pipes: [AsyncPipe], styles: ["[_nghost-%COMP%]{width:100%}.toggle-switch[_ngcontent-%COMP%]{align-items:center;display:flex;flex-direction:row-reverse}.toggle-switch[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{display:none}.toggle-switch[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked + .track[_ngcontent-%COMP%]:after{background-color:var(--chip-active);border-color:var(--chip-active);border-width:2px;height:18px;right:-5px;width:18px}.toggle-switch[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked + .track[_ngcontent-%COMP%]:hover:after{background-color:var(--yellow);border-color:var(--yellow)}.toggle-switch[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{cursor:pointer;flex-grow:1;opacity:.6;transition:opacity .25s}.toggle-switch.checked[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{opacity:1}.toggle-switch[_ngcontent-%COMP%]   .track[_ngcontent-%COMP%]{background-color:#d9d9d9;border-radius:7px;cursor:pointer;height:14px;margin:15px;position:relative;width:34px}.toggle-switch[_ngcontent-%COMP%]   .track[_ngcontent-%COMP%]:after{border:1px solid;border-radius:50%;box-shadow:0 2px 2px rgba(0,0,0,.23921568627450981);content:\"\";height:20px;position:absolute;top:-5px;transition:right .25s,background-color .2s,border-color .3s;width:20px}.toggle-switch[_ngcontent-%COMP%]   .track[_ngcontent-%COMP%]:hover:after{background-color:var(--yellow);border-color:var(--yellow)}.toggle-switch[_ngcontent-%COMP%]   .track[_ngcontent-%COMP%]:after{background-color:var(--chip-disabled);border-color:var(--chip-disabled);right:calc(100% - 10px)}"], changeDetection: 0 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ToggleSwitchComponent, [{
        type: Component,
        args: [{
                selector: 'lib-toggle-switch',
                templateUrl: './toggle-switch.component.html',
                styleUrls: ['./toggle-switch.component.scss'],
                providers: [
                    ToggleSwitchState
                ],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ToggleSwitchState }]; }, { direction: [{
            type: Input,
            args: ['direction']
        }], value$: [{
            type: Input,
            args: ['value']
        }], onChange: [{
            type: Output,
            args: ['toggle']
        }], element: [{
            type: ViewChild,
            args: ['toggle']
        }] }); })();

class ToggleSwitchModule {
}
ToggleSwitchModule.ɵmod = ɵɵdefineNgModule({ type: ToggleSwitchModule });
ToggleSwitchModule.ɵinj = ɵɵdefineInjector({ factory: function ToggleSwitchModule_Factory(t) { return new (t || ToggleSwitchModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ToggleSwitchModule, { declarations: [ToggleSwitchComponent], imports: [CommonModule], exports: [ToggleSwitchComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ToggleSwitchModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ToggleSwitchComponent
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    ToggleSwitchComponent
                ]
            }]
    }], null, null); })();

const _c0$3 = ["*"];
class CardHeaderComponent {
    constructor() { }
    ngOnInit() {
    }
}
CardHeaderComponent.ɵfac = function CardHeaderComponent_Factory(t) { return new (t || CardHeaderComponent)(); };
CardHeaderComponent.ɵcmp = ɵɵdefineComponent({ type: CardHeaderComponent, selectors: [["lib-card-header"]], ngContentSelectors: _c0$3, decls: 2, vars: 0, consts: [[1, "card-header"]], template: function CardHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0);
        ɵɵprojection(1);
        ɵɵelementEnd();
    } }, styles: [".card-header[_ngcontent-%COMP%]{align-items:baseline;background-color:var(--almost-black);color:#fff;display:flex;font-size:20px;justify-content:space-between;padding:32px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CardHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'lib-card-header',
                templateUrl: './card-header.component.html',
                styleUrls: ['./card-header.component.scss']
            }]
    }], function () { return []; }, null); })();

const _c0$4 = ["*"];
class CardContentComponent {
    constructor() { }
    ngOnInit() {
    }
}
CardContentComponent.ɵfac = function CardContentComponent_Factory(t) { return new (t || CardContentComponent)(); };
CardContentComponent.ɵcmp = ɵɵdefineComponent({ type: CardContentComponent, selectors: [["lib-card-content"]], ngContentSelectors: _c0$4, decls: 2, vars: 0, consts: [[1, "card-content"]], template: function CardContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0);
        ɵɵprojection(1);
        ɵɵelementEnd();
    } }, styles: [".card-content[_ngcontent-%COMP%]{padding:32px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CardContentComponent, [{
        type: Component,
        args: [{
                selector: 'lib-card-content',
                templateUrl: './card-content.component.html',
                styleUrls: ['./card-content.component.scss']
            }]
    }], function () { return []; }, null); })();

const _c0$5 = ["*"];
class CardFooterComponent {
    constructor() { }
    ngOnInit() {
    }
}
CardFooterComponent.ɵfac = function CardFooterComponent_Factory(t) { return new (t || CardFooterComponent)(); };
CardFooterComponent.ɵcmp = ɵɵdefineComponent({ type: CardFooterComponent, selectors: [["lib-card-footer"]], ngContentSelectors: _c0$5, decls: 2, vars: 0, consts: [[1, "card-footer"]], template: function CardFooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0);
        ɵɵprojection(1);
        ɵɵelementEnd();
    } }, styles: [".card-footer[_ngcontent-%COMP%]{align-items:baseline;background-color:var(--almost-black);color:#fff;display:flex;font-size:20px;justify-content:space-between;padding:16px 32px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CardFooterComponent, [{
        type: Component,
        args: [{
                selector: 'lib-card-footer',
                templateUrl: './card-footer.component.html',
                styleUrls: ['./card-footer.component.scss']
            }]
    }], function () { return []; }, null); })();

const _c0$6 = ["*"];
class CardComponent {
    constructor() { }
    ngOnInit() {
    }
}
CardComponent.ɵfac = function CardComponent_Factory(t) { return new (t || CardComponent)(); };
CardComponent.ɵcmp = ɵɵdefineComponent({ type: CardComponent, selectors: [["lib-card"]], ngContentSelectors: _c0$6, decls: 2, vars: 0, consts: [[1, "card"]], template: function CardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0);
        ɵɵprojection(1);
        ɵɵelementEnd();
    } }, styles: [".card[_ngcontent-%COMP%]{background-color:#fff;border:2px solid var(--almost-black);border-radius:8px;bottom:0;box-shadow:0 3px 6px rgba(0,0,0,.1607843137254902);left:0;max-width:var(--page-max-width);right:0;top:0}.card[_ngcontent-%COMP%]   form[_ngcontent-%COMP%]{display:flex;flex-direction:column}.card[_ngcontent-%COMP%]   form[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{cursor:text;width:100%}.card[_ngcontent-%COMP%]   form[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%], .card[_ngcontent-%COMP%]   form[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{border:solid var(--almost-black);border-width:0 0 1px;margin-bottom:2em;margin-top:0;padding:0;transition:border-color .25s,margin-top .1s}.card[_ngcontent-%COMP%]   form[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]:focus, .card[_ngcontent-%COMP%]   form[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]:focus{border-color:var(--blue);margin-top:1em;outline:none}.card[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background-color:var(--yellow);border:none;border-radius:4px;cursor:pointer;font-weight:700;padding:.5em;transition:background-color .25s,color .25s}.card[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover{background-color:#ffd782}.card[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:disabled{background-color:grey;color:#a9a9a9;cursor:default}.error[_ngcontent-%COMP%]{color:var(--red);opacity:0;transition:opacity .25s}.error.visible[_ngcontent-%COMP%]{opacity:1}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CardComponent, [{
        type: Component,
        args: [{
                selector: 'lib-card',
                templateUrl: './card.component.html',
                styleUrls: ['./card.component.scss']
            }]
    }], function () { return []; }, null); })();

class CardModule {
}
CardModule.ɵmod = ɵɵdefineNgModule({ type: CardModule });
CardModule.ɵinj = ɵɵdefineInjector({ factory: function CardModule_Factory(t) { return new (t || CardModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(CardModule, { declarations: [CardComponent,
        CardHeaderComponent,
        CardContentComponent,
        CardFooterComponent], imports: [CommonModule], exports: [CardComponent,
        CardHeaderComponent,
        CardContentComponent,
        CardFooterComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(CardModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CardComponent,
                    CardHeaderComponent,
                    CardContentComponent,
                    CardFooterComponent
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    CardComponent,
                    CardHeaderComponent,
                    CardContentComponent,
                    CardFooterComponent
                ]
            }]
    }], null, null); })();

const _c0$7 = ["input"];
const _c1$2 = function (a0) { return { "empty": a0 }; };
class TextInputComponent {
    constructor() {
        this.empty$ = new BehaviorSubject(true);
        this.value$ = new BehaviorSubject(null);
        this.inFocus$ = new BehaviorSubject(false);
        this.onChange = new EventEmitter();
        this.alive = true;
    }
    ngOnDestroy() {
        this.alive = false;
        this.empty$.complete();
    }
    ngAfterViewInit() {
        fromEvent(this.inputRef.nativeElement, 'input').pipe(debounceTime(100), distinctUntilChanged(), map(() => this.inputRef.nativeElement.value), startWith(this.inputRef.nativeElement.value), takeWhile(() => this.alive)).subscribe({
            next: value => {
                const isEmpty = !value || value.length === 0;
                this.empty$.next(isEmpty);
                this.value$.next(value);
                this.onChange.emit(value);
            },
            complete: () => {
                this.empty$.complete();
                this.value$.complete();
            }
        });
        fromEvent(this.inputRef.nativeElement, 'focus').pipe(takeWhile(() => this.alive)).subscribe({ next: () => this.inFocus$.next(true) });
        fromEvent(this.inputRef.nativeElement, 'blur').pipe(takeWhile(() => this.alive)).subscribe({ next: () => this.inFocus$.next(false) });
        fromEvent(this.inputRef.nativeElement, 'animationstart')
            .pipe(tap(e => {
            if (e.animationName === 'onAutoFillStart') {
                const value = this.inputRef.nativeElement.value;
                this.empty$.next(false);
                this.value$.next(value);
                this.onChange.emit(value);
            }
        }), take(1)).subscribe();
    }
    clear() {
        this.inputRef.nativeElement.value = null;
        this.inputRef.nativeElement.dispatchEvent(new InputEvent('input'));
    }
}
TextInputComponent.ɵfac = function TextInputComponent_Factory(t) { return new (t || TextInputComponent)(); };
TextInputComponent.ɵcmp = ɵɵdefineComponent({ type: TextInputComponent, selectors: [["lib-text-input"]], viewQuery: function TextInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$7, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.inputRef = _t.first);
    } }, inputs: { id: ["for", "id"], label: "label", disabled: "disabled", inputType: "inputType" }, outputs: { onChange: "debouncedChange" }, decls: 6, vars: 9, consts: [[1, "input-field"], [3, "type", "disabled"], ["input", ""], [3, "for", "ngClass"]], template: function TextInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelement(1, "input", 1, 2);
        ɵɵelementStart(3, "label", 3);
        ɵɵpipe(4, "async");
        ɵɵtext(5);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("type", ctx.inputType || "text")("disabled", ctx.disabled);
        ɵɵadvance(2);
        ɵɵproperty("for", ctx.id)("ngClass", ɵɵpureFunction1(7, _c1$2, !ctx.empty$ || ɵɵpipeBind1(4, 5, ctx.empty$)));
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.label);
    } }, directives: [NgClass], pipes: [AsyncPipe], styles: ["[_nghost-%COMP%]:not(:first-of-type){margin-top:1em}.input-field[_ngcontent-%COMP%]{display:flex;flex-direction:column}.input-field[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{opacity:.6;padding-left:.3rem;pointer-events:none;transform:translateY(calc(-1em - 4px));transition:transform .25s,opacity .25s;width:100%}.input-field[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:not(.empty){opacity:1;transform:translateY(-2.6em)}.input-field[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{background-color:hsla(0,0%,66.7%,.2);border-radius:.3rem .3rem 0 0;cursor:text}.input-field[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%], .input-field[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{border:solid var(--almost-black);border-width:0 0 1px;margin-top:1em;padding:.3rem}.input-field[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{border-color:var(--blue);outline:none}.input-field[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus + label.empty[_ngcontent-%COMP%]{transform:translateY(-2.6em)}.input-field[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:disabled{cursor:not-allowed;opacity:.5}.input-field[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:disabled + label[_ngcontent-%COMP%]{opacity:.5}input[_ngcontent-%COMP%]:-webkit-autofill{-webkit-animation:onAutoFillStart .25s linear forwards;animation:onAutoFillStart .25s linear forwards}input[_ngcontent-%COMP%]:autofill{-webkit-animation:onAutoFillStart .25s linear forwards;animation:onAutoFillStart .25s linear forwards}@-webkit-keyframes onAutoFillStart{to{color:#0051ff}}@keyframes onAutoFillStart{to{color:#0051ff}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TextInputComponent, [{
        type: Component,
        args: [{
                selector: 'lib-text-input',
                templateUrl: './text-input.component.html',
                styleUrls: ['./text-input.component.scss']
            }]
    }], function () { return []; }, { id: [{
            type: Input,
            args: ['for']
        }], label: [{
            type: Input,
            args: ['label']
        }], disabled: [{
            type: Input,
            args: ['disabled']
        }], inputType: [{
            type: Input,
            args: ['inputType']
        }], inputRef: [{
            type: ViewChild,
            args: ['input']
        }], onChange: [{
            type: Output,
            args: ['debouncedChange']
        }] }); })();

class TextInputModule {
}
TextInputModule.ɵmod = ɵɵdefineNgModule({ type: TextInputModule });
TextInputModule.ɵinj = ɵɵdefineInjector({ factory: function TextInputModule_Factory(t) { return new (t || TextInputModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(TextInputModule, { declarations: [TextInputComponent], imports: [CommonModule], exports: [TextInputComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(TextInputModule, [{
        type: NgModule,
        args: [{
                declarations: [TextInputComponent],
                imports: [
                    CommonModule
                ],
                exports: [
                    TextInputComponent
                ]
            }]
    }], null, null); })();

const _c0$8 = ["button"];
const _c1$3 = ["*"];
class ButtonComponent {
    constructor() { }
    ngAfterViewInit() {
        this.click$ = fromEvent(this.button.nativeElement, 'click');
    }
}
ButtonComponent.ɵfac = function ButtonComponent_Factory(t) { return new (t || ButtonComponent)(); };
ButtonComponent.ɵcmp = ɵɵdefineComponent({ type: ButtonComponent, selectors: [["lib-button"]], viewQuery: function ButtonComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$8, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.button = _t.first);
    } }, inputs: { disabled: "disabled" }, ngContentSelectors: _c1$3, decls: 3, vars: 1, consts: [[3, "disabled"], ["button", ""]], template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "button", 0, 1);
        ɵɵprojection(2);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("disabled", ctx.disabled);
    } }, styles: ["button[_ngcontent-%COMP%]{background-color:var(--yellow);border:none;border-radius:4px;cursor:pointer;font-weight:700;padding:10px 24px;text-align:center;transition:background-color .25s,color .25s}button[_ngcontent-%COMP%]:hover{background-color:#ffd782}button[_ngcontent-%COMP%]:disabled{background-color:grey;color:#a9a9a9;cursor:default}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{
                selector: 'lib-button',
                templateUrl: './button.component.html',
                styleUrls: ['./button.component.scss']
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], button: [{
            type: ViewChild,
            args: ['button']
        }] }); })();

class ButtonModule {
}
ButtonModule.ɵmod = ɵɵdefineNgModule({ type: ButtonModule });
ButtonModule.ɵinj = ɵɵdefineInjector({ factory: function ButtonModule_Factory(t) { return new (t || ButtonModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ButtonModule, { declarations: [ButtonComponent], imports: [CommonModule], exports: [ButtonComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ButtonComponent
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    ButtonComponent
                ]
            }]
    }], null, null); })();

function DropDownComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 11);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r0.title);
} }
function DropDownComponent_li_11_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li", 12);
    ɵɵlistener("click", function DropDownComponent_li_11_Template_li_click_0_listener($event) { ɵɵrestoreView(_r4); const ctx_r3 = ɵɵnextContext(); return ctx_r3.onChoose($event); });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(option_r2);
} }
const _c0$9 = function (a0) { return { "open": a0 }; };
const _c1$4 = function (a0) { return { "empty": a0 }; };
class DropDownComponent {
    constructor() {
        this.open = false;
        this.onSelected = new EventEmitter();
    }
    ngOnChanges(changes) {
        if (!changes.options) {
            return;
        }
        const newOptions = changes.options.currentValue;
        if (newOptions && newOptions.includes(this.selectedOption)) {
            return;
        }
        this.selectedOption = null;
        this.onSelected.emit(this.selectedOption);
    }
    onChoose(event) {
        this.selectedOption = event.target.textContent;
        this.onSelected.emit(this.selectedOption);
    }
}
DropDownComponent.ɵfac = function DropDownComponent_Factory(t) { return new (t || DropDownComponent)(); };
DropDownComponent.ɵcmp = ɵɵdefineComponent({ type: DropDownComponent, selectors: [["lib-drop-down"]], inputs: { title: "title", options: "options" }, outputs: { onSelected: "onSelected" }, features: [ɵɵNgOnChangesFeature], decls: 12, vars: 9, consts: [[1, "dropdown", 3, "ngClass", "click"], [1, "title", 3, "ngClass"], [1, "before"], ["class", "text", 4, "ngIf"], [1, "after"], [1, "value"], [1, "arrow-icon"], [1, "left-bar"], [1, "right-bar"], [1, "options"], ["class", "option", 3, "click", 4, "ngFor", "ngForOf"], [1, "text"], [1, "option", 3, "click"]], template: function DropDownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵlistener("click", function DropDownComponent_Template_div_click_0_listener() { return ctx.open = !ctx.open; });
        ɵɵelementStart(1, "div", 1);
        ɵɵelement(2, "div", 2);
        ɵɵtemplate(3, DropDownComponent_div_3_Template, 2, 1, "div", 3);
        ɵɵelement(4, "div", 4);
        ɵɵelementEnd();
        ɵɵelementStart(5, "span", 5);
        ɵɵtext(6);
        ɵɵelementEnd();
        ɵɵelementStart(7, "div", 6);
        ɵɵelement(8, "span", 7);
        ɵɵelement(9, "span", 8);
        ɵɵelementEnd();
        ɵɵelementStart(10, "ul", 9);
        ɵɵtemplate(11, DropDownComponent_li_11_Template, 2, 1, "li", 10);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngClass", ɵɵpureFunction1(5, _c0$9, ctx.open));
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ɵɵpureFunction1(7, _c1$4, !ctx.selectedOption));
        ɵɵadvance(2);
        ɵɵproperty("ngIf", !!ctx.selectedOption);
        ɵɵadvance(3);
        ɵɵtextInterpolate(ctx.selectedOption || ctx.title);
        ɵɵadvance(5);
        ɵɵproperty("ngForOf", ctx.options);
    } }, directives: [NgClass, NgIf, NgForOf], styles: [".dropdown[_ngcontent-%COMP%]{box-sizing:border-box;cursor:pointer;margin:1.5em 2px;padding:16px;position:relative}.dropdown[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{align-items:baseline;display:flex;font-size:12px;left:0;min-height:19px;position:absolute;top:calc(5px - 1rem);width:100%}.dropdown[_ngcontent-%COMP%]   .title.empty[_ngcontent-%COMP%]{top:0}.dropdown[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{margin:0 4px;white-space:nowrap}.dropdown[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]   .before[_ngcontent-%COMP%]{margin-left:3px;width:8px}.dropdown[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]   .after[_ngcontent-%COMP%]{flex-grow:1}.dropdown[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]   .after[_ngcontent-%COMP%], .dropdown[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]   .before[_ngcontent-%COMP%]{border-bottom:1px solid #000}.dropdown[_ngcontent-%COMP%]:after{border:1px solid #000;border-radius:4px;border-top:none;content:\"\";height:100%;left:0;position:absolute;top:0;width:100%}.dropdown[_ngcontent-%COMP%]:hover:after{border-width:2px;height:calc(100% - 2px);width:calc(100% - 2px)}.dropdown[_ngcontent-%COMP%]:hover   .title[_ngcontent-%COMP%]   .after[_ngcontent-%COMP%], .dropdown[_ngcontent-%COMP%]:hover   .title[_ngcontent-%COMP%]   .before[_ngcontent-%COMP%]{border-width:2px}.dropdown[_ngcontent-%COMP%]   .options[_ngcontent-%COMP%]{background-color:#fff;border-radius:4px;box-shadow:0 1px 3px rgba(0,0,0,.2);display:none;left:0;list-style:none;margin:38px 0 0;padding:0;position:absolute}.dropdown[_ngcontent-%COMP%]   .option[_ngcontent-%COMP%]{cursor:pointer;padding:16px 8px;white-space:nowrap}.dropdown[_ngcontent-%COMP%]   .option[_ngcontent-%COMP%]:hover{background-color:#e8f3ff}.dropdown.open[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]   .after[_ngcontent-%COMP%], .dropdown.open[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]   .before[_ngcontent-%COMP%]{border-color:#2286fc}.dropdown.open[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#2286fc}.dropdown.open[_ngcontent-%COMP%]:after{border-color:#2286fc}.dropdown.open[_ngcontent-%COMP%]   .options[_ngcontent-%COMP%]{display:unset;z-index:1}.arrow-icon[_ngcontent-%COMP%]{display:block;float:right;height:10px;margin:calc(.5em + 2px) 4px .5em .5em;position:relative;width:10px}.left-bar[_ngcontent-%COMP%], .right-bar[_ngcontent-%COMP%]{background-color:transparent;border-radius:2px;display:block;float:right;height:2px;position:absolute;width:10px}.left-bar[_ngcontent-%COMP%]:after, .right-bar[_ngcontent-%COMP%]:after{background-color:#000;content:\"\";display:block;float:right;height:2px;transition:all .5s cubic-bezier(.25,1.7,.35,.8);width:10px;z-index:-1}.left-bar[_ngcontent-%COMP%]{left:0;top:0;transform:rotate(45deg)}.left-bar[_ngcontent-%COMP%]:after{border-radius:6px 10px 10px 6px}.right-bar[_ngcontent-%COMP%]{left:6px;top:0;transform:rotate(-45deg)}.right-bar[_ngcontent-%COMP%]:after{border-radius:10px 6px 6px 10px}.open[_ngcontent-%COMP%]   .left-bar[_ngcontent-%COMP%]:after, .open[_ngcontent-%COMP%]   .right-bar[_ngcontent-%COMP%]:after{background-color:#2286fc;transform-origin:center center}.open[_ngcontent-%COMP%]   .left-bar[_ngcontent-%COMP%]:after{transform:rotate(-90deg)}.open[_ngcontent-%COMP%]   .right-bar[_ngcontent-%COMP%]:after{transform:rotate(90deg)}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DropDownComponent, [{
        type: Component,
        args: [{
                selector: 'lib-drop-down',
                templateUrl: './drop-down.component.html',
                styleUrls: ['./drop-down.component.scss']
            }]
    }], function () { return []; }, { title: [{
            type: Input,
            args: ['title']
        }], options: [{
            type: Input,
            args: ['options']
        }], onSelected: [{
            type: Output
        }] }); })();

class DropDownModule {
}
DropDownModule.ɵmod = ɵɵdefineNgModule({ type: DropDownModule });
DropDownModule.ɵinj = ɵɵdefineInjector({ factory: function DropDownModule_Factory(t) { return new (t || DropDownModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(DropDownModule, { declarations: [DropDownComponent], imports: [CommonModule], exports: [DropDownComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(DropDownModule, [{
        type: NgModule,
        args: [{
                declarations: [DropDownComponent],
                exports: [DropDownComponent],
                imports: [
                    CommonModule
                ]
            }]
    }], null, null); })();

class ComponentInstantiator {
    constructor(resolver) {
        this.resolver = resolver;
    }
    set viewContainerRef(ref) {
        this._viewContainerRef = ref;
    }
    _open(component, componentContainer, options) {
        this._viewContainerRef.clear();
        const factory = this.resolver.resolveComponentFactory(componentContainer);
        const container = this._viewContainerRef.createComponent(factory);
        const content = container.instance.setContent(component, options);
        container.instance.onClose
            .pipe(take(1))
            .subscribe(() => {
            this.close();
        });
        return {
            container: container.instance,
            content: content.instance
        };
    }
    close() {
        this._viewContainerRef.clear();
    }
}
ComponentInstantiator.ɵfac = function ComponentInstantiator_Factory(t) { return new (t || ComponentInstantiator)(ɵɵinject(ComponentFactoryResolver)); };
ComponentInstantiator.ɵprov = ɵɵdefineInjectable({ token: ComponentInstantiator, factory: ComponentInstantiator.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ComponentInstantiator, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ComponentFactoryResolver }]; }, null); })();

class ViewContainerRefDir {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
ViewContainerRefDir.ɵfac = function ViewContainerRefDir_Factory(t) { return new (t || ViewContainerRefDir)(ɵɵdirectiveInject(ViewContainerRef)); };
ViewContainerRefDir.ɵdir = ɵɵdefineDirective({ type: ViewContainerRefDir });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ViewContainerRefDir, [{
        type: Directive,
        args: [{}]
    }], function () { return [{ type: ViewContainerRef }]; }, null); })();

class DialogDirective extends ViewContainerRefDir {
}
DialogDirective.ɵfac = function DialogDirective_Factory(t) { return ɵDialogDirective_BaseFactory(t || DialogDirective); };
DialogDirective.ɵdir = ɵɵdefineDirective({ type: DialogDirective, selectors: [["", "libDialog", ""]], features: [ɵɵInheritDefinitionFeature] });
const ɵDialogDirective_BaseFactory = /*@__PURE__*/ ɵɵgetInheritedFactory(DialogDirective);
/*@__PURE__*/ (function () { ɵsetClassMetadata(DialogDirective, [{
        type: Directive,
        args: [{
                selector: '[libDialog]'
            }]
    }], null, null); })();

const _c0$a = ["dialogContainer"];
function DialogContainerComponent_ng_template_4_Template(rf, ctx) { }
class DialogContainerComponent {
    constructor(resolver, renderer) {
        this.resolver = resolver;
        this.renderer = renderer;
        this.onClose = new EventEmitter();
    }
    ngAfterViewInit() {
        this.applyOptions(this.options);
    }
    setContent(content, options) {
        this.options = options;
        const factory = this.resolver.resolveComponentFactory(content);
        return this.contentHost.viewContainerRef.createComponent(factory);
    }
    applyOptions(options) {
        if (options === null || options === void 0 ? void 0 : options.width) {
            this.renderer.setStyle(this.container.nativeElement, 'width', `${options.width}px`);
        }
        if (options === null || options === void 0 ? void 0 : options.height) {
            this.renderer.setStyle(this.container.nativeElement, 'height', `${options.height}px`);
        }
    }
    dismiss() {
        var _a;
        if (!((_a = this.options) === null || _a === void 0 ? void 0 : _a.sticky)) {
            this.close();
        }
    }
    close() {
        this.onClose.emit();
    }
}
DialogContainerComponent.ɵfac = function DialogContainerComponent_Factory(t) { return new (t || DialogContainerComponent)(ɵɵdirectiveInject(ComponentFactoryResolver), ɵɵdirectiveInject(Renderer2)); };
DialogContainerComponent.ɵcmp = ɵɵdefineComponent({ type: DialogContainerComponent, selectors: [["lib-dialog-container"]], viewQuery: function DialogContainerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(DialogDirective, true);
        ɵɵviewQuery(_c0$a, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.contentHost = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.container = _t.first);
    } }, outputs: { onClose: "onClose" }, decls: 5, vars: 0, consts: [[1, "mouse-capture", 3, "click"], [1, "dialog-container"], [1, "dialog-content"], ["dialogContainer", ""], ["libDialog", ""]], template: function DialogContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵlistener("click", function DialogContainerComponent_Template_div_click_0_listener() { return ctx.dismiss(); });
        ɵɵelementEnd();
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2, 3);
        ɵɵtemplate(4, DialogContainerComponent_ng_template_4_Template, 0, 0, "ng-template", 4);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } }, directives: [DialogDirective], styles: ["[_nghost-%COMP%]{left:0;position:fixed;top:0;z-index:100}.mouse-capture[_ngcontent-%COMP%], [_nghost-%COMP%]{height:100%;width:100%}.mouse-capture[_ngcontent-%COMP%]{-webkit-animation:fade-in .3s ease-in-out;animation:fade-in .3s ease-in-out;background:repeating-linear-gradient(135deg,rgba(0,0,0,.8),rgba(0,0,0,.8) 8px,rgba(0,0,0,.79) 0,rgba(0,0,0,.79) 16px);background-position:50%;background-repeat:repeat;background-size:100%;position:relative}.dialog-container[_ngcontent-%COMP%]{align-items:center;display:flex;height:100%;justify-content:center;left:0;pointer-events:none;position:absolute;top:0;width:100%}.dialog-container[_ngcontent-%COMP%]   .dialog-content[_ngcontent-%COMP%]{-webkit-animation:slide-in .25s ease-in-out;animation:slide-in .25s ease-in-out;pointer-events:all}@-webkit-keyframes fade-in{0%{opacity:0}to{opacity:1}}@keyframes fade-in{0%{opacity:0}to{opacity:1}}@-webkit-keyframes slide-in{0%{opacity:0}30%{opacity:0;transform:translateY(30px) scale(.95)}to{opacity:1;transform:translateY(0) scale(1)}}@keyframes slide-in{0%{opacity:0}30%{opacity:0;transform:translateY(30px) scale(.95)}to{opacity:1;transform:translateY(0) scale(1)}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DialogContainerComponent, [{
        type: Component,
        args: [{
                selector: 'lib-dialog-container',
                templateUrl: './dialog-container.component.html',
                styleUrls: ['./dialog-container.component.scss']
            }]
    }], function () { return [{ type: ComponentFactoryResolver }, { type: Renderer2 }]; }, { contentHost: [{
            type: ViewChild,
            args: [DialogDirective, { static: true }]
        }], onClose: [{
            type: Output
        }], container: [{
            type: ViewChild,
            args: ['dialogContainer']
        }] }); })();

class DialogService extends ComponentInstantiator {
    open(component, options) {
        return super._open(component, DialogContainerComponent, options);
    }
}
DialogService.ɵfac = function DialogService_Factory(t) { return ɵDialogService_BaseFactory(t || DialogService); };
DialogService.ɵprov = ɵɵdefineInjectable({ token: DialogService, factory: DialogService.ɵfac, providedIn: 'root' });
const ɵDialogService_BaseFactory = /*@__PURE__*/ ɵɵgetInheritedFactory(DialogService);
/*@__PURE__*/ (function () { ɵsetClassMetadata(DialogService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class DialogComponent {
    constructor(viewContainerRef, dialog) {
        this.viewContainerRef = viewContainerRef;
        this.dialog = dialog;
    }
    ngAfterViewInit() {
        this.dialog.viewContainerRef = this.viewContainerRef;
    }
}
DialogComponent.ɵfac = function DialogComponent_Factory(t) { return new (t || DialogComponent)(ɵɵdirectiveInject(ViewContainerRef), ɵɵdirectiveInject(DialogService)); };
DialogComponent.ɵcmp = ɵɵdefineComponent({ type: DialogComponent, selectors: [["lib-dialog"]], decls: 0, vars: 0, template: function DialogComponent_Template(rf, ctx) { }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DialogComponent, [{
        type: Component,
        args: [{
                selector: 'lib-dialog',
                template: '',
                styles: ['']
            }]
    }], function () { return [{ type: ViewContainerRef }, { type: DialogService }]; }, null); })();

class DialogModule {
}
DialogModule.ɵmod = ɵɵdefineNgModule({ type: DialogModule });
DialogModule.ɵinj = ɵɵdefineInjector({ factory: function DialogModule_Factory(t) { return new (t || DialogModule)(); }, imports: [[
            CommonModule,
            CardModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(DialogModule, { declarations: [DialogComponent,
        DialogDirective,
        DialogContainerComponent], imports: [CommonModule,
        CardModule], exports: [DialogDirective,
        DialogComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(DialogModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DialogComponent,
                    DialogDirective,
                    DialogContainerComponent
                ],
                imports: [
                    CommonModule,
                    CardModule,
                ],
                exports: [
                    DialogDirective,
                    DialogComponent
                ]
            }]
    }], null, null); })();

class SnackbarDirective extends ViewContainerRefDir {
}
SnackbarDirective.ɵfac = function SnackbarDirective_Factory(t) { return ɵSnackbarDirective_BaseFactory(t || SnackbarDirective); };
SnackbarDirective.ɵdir = ɵɵdefineDirective({ type: SnackbarDirective, selectors: [["", "libSnackbar", ""]], features: [ɵɵInheritDefinitionFeature] });
const ɵSnackbarDirective_BaseFactory = /*@__PURE__*/ ɵɵgetInheritedFactory(SnackbarDirective);
/*@__PURE__*/ (function () { ɵsetClassMetadata(SnackbarDirective, [{
        type: Directive,
        args: [{
                selector: '[libSnackbar]'
            }]
    }], null, null); })();

class SnackbarContainerComponent {
    constructor(resolver) {
        this.resolver = resolver;
        this.color = 'info';
        this.onClose = new EventEmitter();
        this.state = 'created';
    }
    setContent(content, options) {
        const factory = this.resolver.resolveComponentFactory(content);
        const comp = this.contentHost.viewContainerRef.createComponent(factory);
        this.applyOptions(options);
        return comp;
    }
    onAnimationDone(event) {
        const DISMISSED = 'dismissed';
        if (this.state === DISMISSED && event.toState === DISMISSED) {
            this.onClose.emit();
        }
    }
    dismiss() {
        this.state = 'dismissed';
    }
    close() {
        this.onClose.emit();
    }
    applyOptions(options) {
        if (options === null || options === void 0 ? void 0 : options.dismissIn) {
            timer(options.dismissIn)
                .pipe(take(1))
                .subscribe(() => {
                this.state = 'dismissed';
            });
        }
    }
}
SnackbarContainerComponent.ɵfac = function SnackbarContainerComponent_Factory(t) { return new (t || SnackbarContainerComponent)(ɵɵdirectiveInject(ComponentFactoryResolver)); };
SnackbarContainerComponent.ɵcmp = ɵɵdefineComponent({ type: SnackbarContainerComponent, selectors: [["lib-snackbar-container"]], viewQuery: function SnackbarContainerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(SnackbarDirective, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.contentHost = _t.first);
    } }, inputs: { color: "color" }, outputs: { onClose: "onClose" }, decls: 2, vars: 2, consts: [[1, "container", 3, "ngClass"], ["libSnackbar", "", 1, "content"]], template: function SnackbarContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵlistener("@animation.done", function SnackbarContainerComponent_Template_div_animation_animation_done_0_listener($event) { return ctx.onAnimationDone($event); });
        ɵɵelement(1, "div", 1);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("@animation", ctx.state)("ngClass", ctx.color);
    } }, directives: [NgClass, SnackbarDirective], styles: ["[_nghost-%COMP%]{align-items:center;bottom:0;display:flex;flex-direction:column;height:auto;justify-content:center;left:0;overflow:hidden;padding:14px;position:fixed;width:calc(100% - 28px);z-index:100}.container[_ngcontent-%COMP%]{background:#fff;border:2px solid;border-radius:8px;box-shadow:0 2px 2px rgba(0,0,0,.23921568627450981);box-sizing:border-box;color:#18212e}.container.info[_ngcontent-%COMP%]{border-color:var(--chip-hover)}.container.warn[_ngcontent-%COMP%]{border-color:var(--orange)}"], data: { animation: [
            trigger('animation', [
                state('*', style({
                    opacity: 1,
                    transform: 'translateY(0px)'
                })),
                state('void', style({
                    opacity: 0,
                    transform: 'translateY(100px)'
                })),
                state('dismissed', style({
                    opacity: 0,
                    transform: 'translateY(100px)'
                })),
                transition(':enter', [animate('250ms ease-out')]),
                transition(':leave', [animate('250ms ease-in')]),
                transition('* => dismissed', [animate('250ms ease-in')]),
            ])
        ] } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SnackbarContainerComponent, [{
        type: Component,
        args: [{
                selector: 'lib-snackbar-container',
                templateUrl: './snackbar-container.component.html',
                styleUrls: ['./snackbar-container.component.scss'],
                animations: [
                    trigger('animation', [
                        state('*', style({
                            opacity: 1,
                            transform: 'translateY(0px)'
                        })),
                        state('void', style({
                            opacity: 0,
                            transform: 'translateY(100px)'
                        })),
                        state('dismissed', style({
                            opacity: 0,
                            transform: 'translateY(100px)'
                        })),
                        transition(':enter', [animate('250ms ease-out')]),
                        transition(':leave', [animate('250ms ease-in')]),
                        transition('* => dismissed', [animate('250ms ease-in')]),
                    ])
                ]
            }]
    }], function () { return [{ type: ComponentFactoryResolver }]; }, { color: [{
            type: Input
        }], onClose: [{
            type: Output
        }], contentHost: [{
            type: ViewChild,
            args: [SnackbarDirective, { static: true }]
        }] }); })();

class SnackbarService extends ComponentInstantiator {
    open(component, options) {
        return super._open(component, SnackbarContainerComponent, options);
    }
}
SnackbarService.ɵfac = function SnackbarService_Factory(t) { return ɵSnackbarService_BaseFactory(t || SnackbarService); };
SnackbarService.ɵprov = ɵɵdefineInjectable({ token: SnackbarService, factory: SnackbarService.ɵfac, providedIn: 'root' });
const ɵSnackbarService_BaseFactory = /*@__PURE__*/ ɵɵgetInheritedFactory(SnackbarService);
/*@__PURE__*/ (function () { ɵsetClassMetadata(SnackbarService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class SnackbarComponent {
    constructor(viewContainerRef, snackbar) {
        this.viewContainerRef = viewContainerRef;
        this.snackbar = snackbar;
    }
    ngAfterViewInit() {
        this.snackbar.viewContainerRef = this.viewContainerRef;
    }
}
SnackbarComponent.ɵfac = function SnackbarComponent_Factory(t) { return new (t || SnackbarComponent)(ɵɵdirectiveInject(ViewContainerRef), ɵɵdirectiveInject(SnackbarService)); };
SnackbarComponent.ɵcmp = ɵɵdefineComponent({ type: SnackbarComponent, selectors: [["lib-snackbar"]], decls: 0, vars: 0, template: function SnackbarComponent_Template(rf, ctx) { }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SnackbarComponent, [{
        type: Component,
        args: [{
                selector: 'lib-snackbar',
                template: '',
            }]
    }], function () { return [{ type: ViewContainerRef }, { type: SnackbarService }]; }, null); })();

class SnackbarModule {
}
SnackbarModule.ɵmod = ɵɵdefineNgModule({ type: SnackbarModule });
SnackbarModule.ɵinj = ɵɵdefineInjector({ factory: function SnackbarModule_Factory(t) { return new (t || SnackbarModule)(); }, imports: [[
            BrowserModule,
            BrowserAnimationsModule,
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(SnackbarModule, { declarations: [SnackbarComponent,
        SnackbarContainerComponent,
        SnackbarDirective], imports: [BrowserModule,
        BrowserAnimationsModule,
        CommonModule], exports: [SnackbarComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(SnackbarModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SnackbarComponent,
                    SnackbarContainerComponent,
                    SnackbarDirective
                ],
                imports: [
                    BrowserModule,
                    BrowserAnimationsModule,
                    CommonModule
                ],
                exports: [
                    SnackbarComponent
                ]
            }]
    }], null, null); })();

const _c0$b = ["*"];
class CheckboxComponent {
    constructor() {
        this.checked$ = new BehaviorSubject(this.checked);
        this.onChecked = new EventEmitter(true);
    }
    set checked(value) {
        this.checked$.next(value);
    }
    ngOnInit() {
    }
    onChange(event) {
        const value = event.target.checked;
        this.checked$.next(value);
        this.onChecked.next(value);
    }
}
CheckboxComponent.ɵfac = function CheckboxComponent_Factory(t) { return new (t || CheckboxComponent)(); };
CheckboxComponent.ɵcmp = ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["lib-checkbox"]], inputs: { checked: "checked" }, outputs: { onChecked: "onChecked" }, ngContentSelectors: _c0$b, decls: 6, vars: 3, consts: [["type", "checkbox", 3, "checked", "click"], [1, "label-content"], [1, "checkmark"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "label");
        ɵɵelementStart(1, "input", 0);
        ɵɵlistener("click", function CheckboxComponent_Template_input_click_1_listener($event) { return ctx.onChange($event); });
        ɵɵpipe(2, "async");
        ɵɵelementEnd();
        ɵɵelementStart(3, "span", 1);
        ɵɵprojection(4);
        ɵɵelementEnd();
        ɵɵelement(5, "span", 2);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("checked", ɵɵpipeBind1(2, 1, ctx.checked$));
    } }, pipes: [AsyncPipe], styles: ["[_nghost-%COMP%]{-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;display:block;margin:10px 0;padding-left:1.5rem;position:relative;user-select:none}[_nghost-%COMP%]:hover   input[_ngcontent-%COMP%] ~ .checkmark[_ngcontent-%COMP%]{background-color:var(--chip-disabled)}[_nghost-%COMP%]:hover   input[_ngcontent-%COMP%] ~ .checkmark[_ngcontent-%COMP%]:after, [_nghost-%COMP%]:hover   input[_ngcontent-%COMP%] ~ .checkmark[_ngcontent-%COMP%]:before{border-color:#fff}[_nghost-%COMP%]:hover   input[_ngcontent-%COMP%]:checked ~ .checkmark[_ngcontent-%COMP%]{background-color:var(--chip-hover)}[_nghost-%COMP%]:hover   input[_ngcontent-%COMP%]:checked ~ .checkmark[_ngcontent-%COMP%]:before{border-color:transparent}label[_ngcontent-%COMP%]{vertical-align:text-top}input[_ngcontent-%COMP%], label[_ngcontent-%COMP%]{cursor:pointer}input[_ngcontent-%COMP%]{height:0;opacity:0;position:absolute;width:0}input[_ngcontent-%COMP%]:checked ~ .checkmark[_ngcontent-%COMP%]{background-color:#fff}input[_ngcontent-%COMP%]:checked ~ .checkmark[_ngcontent-%COMP%]:after{display:block}input[_ngcontent-%COMP%]:checked ~ .checkmark[_ngcontent-%COMP%]:before{border-color:transparent}input[_ngcontent-%COMP%]:checked ~ .label-content[_ngcontent-%COMP%]{color:#fff}input[_ngcontent-%COMP%] ~ .label-content[_ngcontent-%COMP%]{color:var(--chip-disabled);transition:color .25s ease-out}.checkmark[_ngcontent-%COMP%]{background-color:transparent;border-radius:4px;height:18px;left:0;position:absolute;top:0;width:18px}.checkmark[_ngcontent-%COMP%]:after{border:solid #000;border-width:0 2px 2px 0;content:\"\";display:none;height:8px;left:6px;position:absolute;top:3px;transform:rotate(45deg);width:3px}.checkmark[_ngcontent-%COMP%]:before{border:2px solid var(--chip-disabled);border-radius:4px;box-sizing:border-box;content:\"\";height:100%;left:0;position:absolute;top:0;width:100%}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'lib-checkbox',
                templateUrl: './checkbox.component.html',
                styleUrls: ['./checkbox.component.scss']
            }]
    }], function () { return []; }, { onChecked: [{
            type: Output
        }], checked: [{
            type: Input
        }] }); })();

class CheckboxModule {
}
CheckboxModule.ɵmod = ɵɵdefineNgModule({ type: CheckboxModule });
CheckboxModule.ɵinj = ɵɵdefineInjector({ factory: function CheckboxModule_Factory(t) { return new (t || CheckboxModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(CheckboxModule, { declarations: [CheckboxComponent], imports: [CommonModule], exports: [CheckboxComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(CheckboxModule, [{
        type: NgModule,
        args: [{
                declarations: [CheckboxComponent],
                imports: [
                    CommonModule
                ],
                exports: [
                    CheckboxComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of elements-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonComponent, ButtonModule, CardComponent, CardContentComponent, CardFooterComponent, CardHeaderComponent, CardModule, CheckboxComponent, CheckboxModule, ChipComponent, ChipModule, ChipStatus, DialogComponent, DialogDirective, DialogModule, DialogService, DropDownComponent, DropDownModule, ElementsLibComponent, ElementsLibModule, ElementsLibService, HeaderComponent, HeaderModule, SnackbarComponent, SnackbarModule, SnackbarService, TextInputComponent, TextInputModule, ToggleSwitchComponent, ToggleSwitchModule, TopNavBarComponent, TopNavModule };
//# sourceMappingURL=elements-lib.js.map
